import React, { useRef } from 'react';
import { Loader2, FileSpreadsheet } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Label } from '../../../ui/label';
import { Textarea } from '../../../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../ui/dialog';

// Generic CSV import dialog (colors or materials); parent owns parsing + import.
export const CsvImportDialog = ({
  open, onOpenChange, title, columnsHint, placeholder, entityLabel,
  csvText, onTextChange, preview, renderPreviewRow, onImport, saving, testId,
}) => {
  const fileRef = useRef(null);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => onTextChange(ev.target?.result || '');
    reader.readAsText(file);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid={testId}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <p className="text-sm text-neutral-500">Upload a CSV file with columns: {columnsHint}</p>
          <div>
            <input ref={fileRef} type="file" accept=".csv" onChange={handleFile} className="hidden" />
            <Button variant="outline" onClick={() => fileRef.current?.click()} className="w-full gap-2">
              <FileSpreadsheet className="w-4 h-4" /> Choose CSV File
            </Button>
          </div>
          <div>
            <Label>Or paste CSV data:</Label>
            <Textarea value={csvText} onChange={(e) => onTextChange(e.target.value)} placeholder={placeholder} rows={5} className="mt-1 font-mono text-xs" />
          </div>
          {preview.length > 0 && (
            <div className="border rounded-lg p-3 bg-neutral-50 max-h-48 overflow-y-auto">
              <p className="text-sm font-medium mb-2">Preview ({preview.length} {entityLabel}):</p>
              <div className="space-y-1">
                {preview.slice(0, 10).map((row, i) => <React.Fragment key={i}>{renderPreviewRow(row)}</React.Fragment>)}
                {preview.length > 10 && <p className="text-xs text-neutral-400">...and {preview.length - 10} more</p>}
              </div>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onImport} disabled={saving || preview.length === 0} className="bg-amber-600 hover:bg-amber-700">
            {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            Import {preview.length} {entityLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CsvImportDialog;
